import { render, staticRenderFns } from "./TenantDetailsEditTenant.vue?vue&type=template&id=96052c7c"
import script from "./TenantDetailsEditTenant.vue.ts?vue&type=script&lang=ts&external"
export * from "./TenantDetailsEditTenant.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports